import React, { useMemo } from "react";
import { Card, CardBody, CardHeader } from "reactstrap";
import TableContainer from "../../../../Components/Common/TableContainer";

const TopRevenueRooms = ({ rooms = [] }) => {

  const getBadge = (revenue) => {
    if (revenue >= 50000) {
      return (
        <span className="badge bg-success-subtle text-success text-uppercase">
          High
        </span>
      );
    }

    if (revenue >= 20000) {
      return (
        <span className="badge bg-warning-subtle text-warning text-uppercase">
          Medium
        </span>
      );
    }

    return (
      <span className="badge bg-danger-subtle text-danger text-uppercase">
        Low
      </span>
    );
  };

  const tableData = rooms.map((room) => ({
    room: room.room,
    revenue: room.revenue,
  }));

  const columns = useMemo(
    () => [
      {
        header: "Room",
        accessorKey: "room",
        enableColumnFilter: false,
      },
      {
        header: "Revenue",
        accessorKey: "revenue",
        enableColumnFilter: false,
        cell: ({ getValue }) =>
          `₹${Number(getValue()).toLocaleString()}`,
      },
      {
        header: "Performance",
        accessorKey: "revenue",
        enableColumnFilter: false,
        cell: ({ getValue }) => getBadge(getValue()),
      },
    ],
    []
  );

  return (
    <Card style={{ height: "430px" }}>
      <CardHeader>
        <h4 className="card-title mb-0 flex-grow-1">
          Top Revenue Rooms
        </h4>
      </CardHeader>

      <CardBody>
        <TableContainer
          columns={columns}
          data={tableData}
          customPageSize={5}
          isPagination
          className="text-nowrap"
          theadClass="bg-light"
        />
      </CardBody>
    </Card>
  );
};

export default TopRevenueRooms;